<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/notifications/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش اعلان</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-text-field color="black" v-model="notification.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-select
                label="فوریت اعلان را مشخص کنید"
                :items="[{value:'high',text:'بالا'},{value:'normal',text:'متوسط'},{value:'low',text:'پایین'}]"
                v-model="notification.priority"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="2">
            <v-select
                label="بخش اعلان را مشخص کنید"
                :items="sections"
                v-model="notification.section"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="2">
            <v-select
                label="رنگ اعلان را مشخص کنید"
                :items="colors"
                v-model="notification.color"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <v-checkbox
                label="اعلان پس از ورود به کاربر نمایش داده شود؟"
                v-model="notification.show_after_login"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
                label="اعلان با صدا پخش شود؟"
                v-model="notification.has_sound_alert"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
                label="اعلان در زمان دیگری ارسال شود؟"
                v-model="notification.has_schedule"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
                label="اعلان فایل ضمیمه دارد؟"
                v-model="notification.has_attachment"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
                label="اعلان در وضعیت پیش نویس ذخیره شود؟"
                v-model="notification.status"
                color="black"
                value="draft"
            >
            </v-checkbox>
          </v-col>
          <v-col v-if="notification.has_schedule" cols="2">
            <vue-persian-datetime-picker color="black" v-model="notification.send_at"
                                         type="datetime"
                                         custom-input="#send_at"
                                         auto-submit></vue-persian-datetime-picker>
            <v-text-field label="تاریخ و زمان ارسال اعلان" v-model="notification.send_at" id="send_at"
                          color="black">
            </v-text-field>
          </v-col>
          <v-col v-if="notification.has_attachment" cols="2">
            <v-select
                label="نوع فایل اعلان را مشخص کنید"
                :items="attachment_types"
                v-model="notification.attachment_type"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="4" v-if="notification.has_attachment">
            <v-text-field label="فایل"
                          @click="fileDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="notification.url"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea color="black" v-model="notification.content" label="محتوای اعلان"></v-textarea>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="update()">ویرایش</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="fileDialog" max-width="50vw">
      <drag-and-drop module="item" ref="image-uploader" @closeUploadFileDialog="fileDialog = false"
                     @changeFile="notification.url = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "NotificationEdit",
  components: {DragAndDrop, VuePersianDatetimePicker},
  data() {
    return {
      fileDialog: false,
      sections: [
        {value: 'concert', text: 'کنسرت'},
        {value: 'change_program', text: 'تغییر در برنامه'},
        {value: 'news', text: 'خبر'},
        {value: 'offer', text: 'پیشنهاد'},
        {value: 'general', text: 'عمومی'},
      ],
      colors: [
        {value: 'white', text: 'سفید'},
        {value: '#6ea9f2', text: 'آبی درکی'},
        {value: 'black', text: 'مشکی'},
        {value: 'orange', text: 'نارنجی'},
        {value: 'red', text: 'قرمز'},
      ],
      attachment_types: [
        {value: 'audio', text: 'فایل صوتی'},
        {value: 'video', text: 'ویدیو'},
        {value: 'pdf', text: 'پی دی اف'},
        {value: 'image', text: 'تصویر'},
        {value: 'zip', text: 'فایل فشرده'},
      ],
      notification: {
        title: null,
        content: null,
        instructor_ids: null,
        student_ids: null,
        priority: 'normal',
        section: 'general',
        color: '#6ea9f2',
        has_sound_alert: null,
        has_attachment: null,
        show_after_login: null,
        has_schedule: null,
        url: null,
        attachment_type: null,
        send_at: null,
        status: 'waiting'
      }
    }
  },
  mounted() {
    this.getNotification()
  },
  methods: {
    getNotification() {
      window.axios.get('notification/crud/get/' + this.$route.params.id).then((res) => {
        this.notification = res.data.data
        this.notification.send_at = res.data.data.send_at_fa
      })
    },
    update() {
      if (!this.notification.status){
        this.notification.status = 'draft'
      }
      window.axios.post('notification/crud/update/' + this.$route.params.id, this.notification).then(() => {
        this.openSnackbar("اعلان مورد نظر با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
  }
}
</script>

<style scoped>

</style>